export const GamificationEndpoints = {
  gamificationToggle: (membershipId: string) => `/rest/v1/gamification/${membershipId}/toggle`,
  getRanking: (membershipId: string) => `/rest/v1/gamification/${membershipId}/position`
}
